var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7052 15H39.2948C36.9229 15 35 16.8507 35 19.1336V42.8664C35 45.1493 36.9229 47 39.2948 47H41.7052C44.0771 47 46 45.1493 46 42.8664V19.1336C46 16.8507 44.0771 15 41.7052 15Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0956 15H20.9044C18.7481 15 17 16.8507 17 19.1336V42.8664C17 45.1493 18.7481 47 20.9044 47H23.0956C25.2519 47 27 45.1493 27 42.8664V19.1336C27 16.8507 25.2519 15 23.0956 15Z",
    fill: "#9C9C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7052 16H40.2948C37.9229 16 36 17.9085 36 20.2627V44.7373C36 47.0915 37.9229 49 40.2948 49H42.7052C45.0771 49 47 47.0915 47 44.7373V20.2627C47 17.9085 45.0771 16 42.7052 16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7052 16H22.2948C19.9229 16 18 17.9085 18 20.2627V44.7373C18 47.0915 19.9229 49 22.2948 49H24.7052C27.0771 49 29 47.0915 29 44.7373V20.2627C29 17.9085 27.0771 16 24.7052 16Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/pause.10ced851.svg";
export { SvgPause as ReactComponent };